import firebase from "firebase/compat/app";
import {db, storage} from "../firebase";
import {MissingType} from "../db/models/extra";
import {ContentType} from "../db/models/content";
import {getUid} from "./auth";
import {Collections} from "./collections";
import {uploadMediaToStorage} from "./storage";

export const addContentDocAndMedia = (file: any, partialContent: any) => {
    const uid = getUid();
    if (!file || !partialContent || !uid) return Promise.reject("bad params");

    const docRef = db.collection(Collections.CONTENTS).doc();
    const docId = docRef.id;
    const storagePath = `${uid}/${Collections.CONTENTS}/${docId}/video`;

    return uploadMediaToStorage(file, storagePath).then((downloadUrl) => {
        const content: ContentType = {
            ...partialContent,
            id: docId,
            sources: [downloadUrl],
            created: firebase.firestore.FieldValue.serverTimestamp(),
            userId: uid,
        };
        return docRef.set(content);
    });
};

export const updateContentDocAndMedia = (
    file: any,
    updatedContent: ContentType
) => {
    const uid = getUid();
    if (!file || !updatedContent || !uid) return Promise.reject("bad params");

    const storagePath = `${uid}/${Collections.CONTENTS}/${updatedContent.id}/video`;

    return uploadMediaToStorage(file, storagePath).then((downloadUrl) => {
        const content: ContentType = {
            ...updatedContent,
            updated: firebase.firestore.FieldValue.serverTimestamp(),
            sources: [downloadUrl],
        };
        return db
            .collection(Collections.CONTENTS)
            .doc(updatedContent.id)
            .update(content);
    });
};

export const deleteContentDocAndMedia = async (uid: string, contentId: string) => {
    if (!uid || !contentId) return Promise.reject("bad params");

    const storagePath = `${uid}/${Collections.CONTENTS}/${contentId}/video`;
    const storageRef = storage.ref().child(storagePath);

    await storageRef.delete();

    return db.collection(Collections.CONTENTS).doc(contentId).delete();
}

export const updateContent = (updatedContent: ContentType) => {
    const content: ContentType = {
        ...updatedContent,
        updated: firebase.firestore.FieldValue.serverTimestamp(),
    };
    return db
        .collection(Collections.CONTENTS)
        .doc(updatedContent.id)
        .update(content);
};

export const getRmContentsListener = (rmId: string, cb: MissingType) => {
    if (!rmId) return Promise.reject();

    return db
        .collection(Collections.CONTENTS)
        .where("rmId", "==", rmId)
        .onSnapshot(cb);
};

export const getContentsByRmId = async (rmId: string): Promise<ContentType[]> => {
    if (!rmId) return Promise.resolve([]);

    const snap = await db
        .collection(Collections.CONTENTS)
        .where("rmId", "==", rmId)
        .get();
    return snap.docs.map((doc) => doc.data() as ContentType);
};
